/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InternalUserNewsResponseV3TypeEnum = {
    News: 'news'
};
/**
 * Check if a given object implements the InternalUserNewsResponseV3 interface.
 */
export function instanceOfInternalUserNewsResponseV3(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('subject' in value) || value['subject'] === undefined)
        return false;
    return true;
}
export function InternalUserNewsResponseV3FromJSON(json) {
    return InternalUserNewsResponseV3FromJSONTyped(json, false);
}
export function InternalUserNewsResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'subject': json['subject'],
        'sanitizedContent': json['sanitized_content'] == null ? undefined : json['sanitized_content'],
        'coverPicture': json['cover_picture'] == null ? undefined : json['cover_picture'],
    };
}
export function InternalUserNewsResponseV3ToJSON(json) {
    return InternalUserNewsResponseV3ToJSONTyped(json, false);
}
export function InternalUserNewsResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'subject': value['subject'],
        'sanitized_content': value['sanitizedContent'],
        'cover_picture': value['coverPicture'],
    };
}
